import { Box, List, ListItem, Stack, Typography } from '@mui/material';
import section10_image from 'assets/img/ECommerce/section10_image.png';
import AnimatedButton from 'components/common/AnimatedButton';
import React, { JSX } from 'react';
import { E_COMMERCE_STYLES } from './config';
import { paths } from 'routes/routes/paths';
import { Link } from 'react-router-dom';

export default function Section10(): JSX.Element {
  return (
    <Box sx={{ px: 0, bgcolor: '#010202', color: '#e5e7eb' }}>
      <Box
        component="img"
        src={section10_image}
        alt="hero"
        sx={{
          width: '100%',
          position: 'relative',
        }}
      />
      <Stack
        spacing={3}
        maxWidth={E_COMMERCE_STYLES.container.maxWidth}
        mx={E_COMMERCE_STYLES.container.mx}
        px={3}
        pb={10}
      >
        <Typography variant="h3" className="font-helvetica-bold">
          Dedicated Support From the Team That Built It
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography variant="body2" className="font-helvetica-light" color="white">
            You're not left on your own after launch. You get ongoing support, fast resolutions, and
            future upgrades — from the same expert team that built your system.
          </Typography>

          <Typography variant="body2" className="font-helvetica-light" color="white">
            What’s Included:
          </Typography>

          <List sx={{ listStyle: 'disc', pl: 3, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0, mb: 1 }}>
              <Typography variant="body2" className="font-helvetica-light" color="white">
                Direct access to developers and engineers
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0, mb: 1 }}>
              <Typography variant="body2" className="font-helvetica-light" color="white">
                Priority issue resolution & performance monitoring
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              <Typography variant="body2" className="font-helvetica-light" color="white">
                Regular feature updates and improvements
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              <Typography variant="body2" className="font-helvetica-light" color="white">
                Business continuity support at enterprise standards
              </Typography>
            </ListItem>
          </List>
        </Box>

        <Stack>
          <Typography
            variant="body2"
            className="font-helvetica-thin"
            color="white"
            fontSize={68}
            whiteSpace={'nowrap'}
          >
            1‑Year ✨
          </Typography>
          <Typography variant="body2" className="font-helvetica-thin" color="white" fontSize={30}>
            Premium AMC & Support, Worth $50K
          </Typography>
          <Typography variant="body2" className="font-helvetica-bold" color="white" fontSize={30}>
            Absolutely FREE!!!
          </Typography>
        </Stack>

        <Stack>
          <Link to={paths.public.schedule}>
            <AnimatedButton
              label="Meet our Tech Team Online"
              sx={{ mt: 1.5, whiteSpace: 'nowrap', gap: 1 }}
            />
          </Link>

          <Typography
            mt={1}
            maxWidth={'270px'}
            variant="body2"
            color="#5775C7"
            className="font-serif"
          >
            Just a{' '}
            <b>
              <u> 60-minute deep dive</u>{' '}
            </b>{' '}
            into what’s holding you back — and how to fix it.
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
